import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import ParticipantList from '../ParticipantList/ParticipantList';
import MainParticipant from '../MainParticipant/MainParticipant';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import useParticipants from '../VideoProvider/useParticipants/useParticipants';

const useStyles = makeStyles((theme: Theme) => {
  const totalMobileSidebarHeight = `${theme.sidebarMobileHeight +
    theme.sidebarMobilePadding * 2 +
    theme.participantBorderWidth}px`;
  const totalSidebarHeight = `${theme.headerHeight + theme.headerPadding * 2 + theme.participantBorderWidth}px`;

  return {
    container: {
      position: 'relative',
      height: '100%',
      display: 'grid',
      gridTemplateColumns: `100%`,
      gridTemplateRows: `${totalSidebarHeight} calc(100% - ${totalSidebarHeight})`,
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: `100%`,
        gridTemplateRows: `${totalMobileSidebarHeight} calc(100% - ${totalMobileSidebarHeight})`,
      },
    },
    chatWindowOpen: { gridTemplateColumns: `1fr ${theme.sidebarWidth}px ${theme.chatWindowWidth}px` },
    fullScreen: {
      gridTemplateRows: '0 100%',
    },
  };
});

export default function Room() {
  const participants = useParticipants();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const classes = useStyles();
  const { isChatWindowOpen } = useChatContext();
  return (
    <div
      className={clsx(classes.container, {
        [classes.chatWindowOpen]: isChatWindowOpen,
        [classes.fullScreen]: isMobile && !participants.length,
      })}
    >
      <MainParticipant />
      <ParticipantList />
    </div>
  );
}
